import queryString from 'querystring';
import { TIME } from '../helpers/time';

const beaconsServerUrl = process.env.BEACONS_SERVER_URL || 'https://s2.pluto.tv/';
const MAX_RETRIES = 5;

/*
Stores the message, and retry sending (up to MAX_RETRIES) if there was an error
 */
const messages = new Map();

function postData(url, payload) {
  const data = queryString.stringify(payload);
  return fetch(url, {
    body: data,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    method: 'POST',
  });
}

const doSend = () => {
  messages.forEach((count, msg) => {
    const newMsg = Object.assign({}, msg, {
      custom1: msg.custom1 ? msg.custom1 + 1 : 1,
    });
    postData(beaconsServerUrl, newMsg).catch((error) => {
      if (count < MAX_RETRIES) {
        messages.set(newMsg, count + 1);
      } else {
        console.warn("Can't send to server (dropping): ", JSON.stringify(msg), error.message);
      }
    });
    messages.delete(msg);
  });
};

/**
 * @param dataAsObj ie:  { answer: 42 }
 */
const sendToServer = (dataAsObj) => {
  messages.set(dataAsObj, 0);
};

setInterval(doSend, TIME.ONE_SEC_IN_MS);

export { sendToServer };
